import type { PropType } from 'vue';

import type { TEchartsBarDatasetItem, TEChartsTitleConfig, TEChartsValueFormatter } from '../types';

export const ECHARTS_BAR_CHART_PROPS = {
  labels: {
    type: Array as PropType<string[]>,
    default: () => [],
  },
  tooltipLabels: {
    type: Array as PropType<string[]>,
    default: undefined,
  },
  dataset: {
    type: Array as PropType<TEchartsBarDatasetItem[]>,
    default: () => [],
  },
  titleConfig: {
    type: Object as PropType<TEChartsTitleConfig>,
  },
  emptyMessage: {
    type: String,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
  height: {
    type: Number,
    default: 550,
  },
  formatLabel: {
    type: String,
    default: '',
  },
  labelColor: {
    type: String,
    default: '#787f8f',
  },
  legendIcon: {
    type: String,
    default: 'circle',
  },
  legendSelectable: {
    type: Boolean,
    default: true,
  },
  showTooltip: {
    type: Boolean,
    default: true,
  },
  formatLabelFunction: {
    type: Function as unknown as PropType<((value: number | string) => string) | null>,
    default: null,
  },
  formatValueFunction: {
    type: Function as unknown as PropType<TEChartsValueFormatter | null>,
    default: null,
  },
  valueFractionDigits: {
    type: Number,
  },
  barMaxWidth: {
    type: Number,
    default: undefined,
  },
  stack: {
    type: [Boolean, String] as PropType<boolean | string>,
    default: false,
  },
  /** В tooltip для stack показывать накопленную сумму снизу вверх (как Apex overlap) */
  stackTooltipCumulative: {
    type: Boolean,
    default: false,
  },
  /** Порядок строк в tooltip сверху вниз (как Apex tooltip.inverseOrder) */
  tooltipInverseOrder: {
    type: Boolean,
    default: false,
  },
};
